import React from "react";
import styles from "./formSection.module.scss";
import ContactUsForm from "@components/shared/contactUs/contactUsForm";
import Address from "@components/shared/contactUsIcons/address";
import Letter from "@components/shared/contactUsIcons/mail";
import { useDomainContext } from "@hooks/useDomainContext";
import { replaceStringVariables } from "@lib/sharedUtils";
const FormSection = ({
    iconsFillColor,
    invisibleRecaptcha,
}: {
    iconsFillColor?: string;
    invisibleRecaptcha?: boolean;
}) => {
    const { domain, category, domainNameTranslation } = useDomainContext();
    const contactUsAddress =
        category?.config?.contactUsAddress ??
        category?.parentCategory?.config?.contactUsAddress;

    const addressTranslation =
        domain?.translations?.[`${domainNameTranslation}_contactUsAddress`];

    let address = addressTranslation
        ? addressTranslation
              ?.replace(/\$\{domainName\}/gi, domain?.name || "")
              ?.replace(/\$\{domainNiceName\}/gi, domain?.niceName || "")
        : `<strong>3rd floor 324,</strong><br />
        <strong>Wasfi Tal Street , Amman Jordan.</strong><br /><br />
        <strong>Phone:</strong> <a href='tel:+18888668085'>1 (888) 866-8085</a><br /><br />
        <strong>Email:</strong> <a href='mailto:info@${domain.name}'>info@${domain.niceName}</a><br />`;

    if (contactUsAddress) {
        address = replaceStringVariables(contactUsAddress, {
            domainName: domain.name,
            domainNiceName: domain.niceName,
        });
    }

    return (
        <div className={`${styles.bg}`}>
            <div className="flex flex-col lg:flex-row justify-between pt-36 pb-16 px-4">
                <div className="flex flex-col justify-center lg:w-6/12 mb-8">
                    <div className="flex flex-col mb-8">
                        <span className="w-16 mb-3">
                            <Letter fill={iconsFillColor} />
                        </span>
                        <h1 className="font-bold text-xl w-9/12">
                            {domain?.translations?.[
                                `${domainNameTranslation}_contactUsAnyQuestionLabel`
                            ] ??
                                `Any Question or remarks? Just write us a message!`}
                        </h1>
                        <p className="w-9/12">
                            {domain?.translations?.[
                                `${domainNameTranslation}_contactUsFillFormLabel`
                            ] ??
                                `Fill up the form and our team will get back to you within 24 hours`}
                        </p>
                    </div>
                    <div className="flex flex-col text-sm">
                        <span className="w-16 mb-3">
                            <Address fill={iconsFillColor} />
                        </span>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: address,
                            }}
                        ></p>
                    </div>
                </div>
                <div className={`lg:w-6/12 p-10 bg-white ${styles.form}`}>
                    <ContactUsForm
                        primaryColor={iconsFillColor ?? "#5dbbfe"}
                        secondaryColor="#000000"
                        classes={{
                            formClassName: styles["form"],
                            fieldWrapperClassName: styles["field-wrapper"],
                            fieldClassName: styles["field"],
                        }}
                        severalBrandsRecaptcha={invisibleRecaptcha}
                    />
                </div>
            </div>
        </div>
    );
};
export default FormSection;
